import e from "react";
import $ from "classnames";
import { t as R } from "./utils-Ci4OZEP4.es.js";
import { u as h } from "./ThemeProvider--i7ESlT5.es.js";
import { u as k } from "./DarkModeProvider-xoZXm3ct.es.js";
import { T as u } from "./index-BB-Wk85r.es.js";
import { I as w } from "./InputError-I0ejYOQJ.es.js";
import './RadioGroup.css';const B = "Radio-module__radioButton___83sOM", C = "Radio-module__dark___YNElO", G = "Radio-module__compere___UpoCn", D = "Radio-module__label___Znh-K", I = "Radio-module__outline___yqS85", x = "Radio-module__fill___fXQyZ", M = "Radio-module__error___MN9E1", Z = "Radio-module__container___ZAhgA", A = "Radio-module__radioGroup___WbS8D", K = "Radio-module__svg___Zs3K4", o = {
  radioButton: B,
  dark: C,
  default: "Radio-module__default___DHlbp",
  compere: G,
  label: D,
  outline: I,
  fill: x,
  error: M,
  container: Z,
  radioGroup: A,
  svg: K
}, y = e.forwardRef(
  ({
    value: r,
    name: n,
    label: a,
    selected: s = !1,
    onSelect: d,
    tabIndex: c = 0,
    labelVariant: i = "Body2",
    size: m = 26,
    id: _,
    ariaLabelledBy: t,
    error: E = !1
  }, b) => {
    const g = h(), v = k(), N = u[i] ?? u.Body2, l = m / 16, p = {
      cy: `${l / 2}rem`,
      cx: `${l / 2}rem`
    };
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        ref: b,
        id: _,
        role: "radio",
        "aria-checked": s,
        "aria-labelledby": t ?? R(`${n}-${r}`),
        tabIndex: c,
        className: $(o.radioButton, o[g], {
          [o.error]: E,
          [o.dark]: v
        }),
        onClick: () => d(r),
        onKeyDown: (f) => {
          f.key === " " && (f.preventDefault(), d(r));
        }
      },
      /* @__PURE__ */ e.createElement(
        "div",
        {
          className: o.container,
          style: {
            width: `${l}rem`,
            height: `${l}rem`
          }
        },
        /* @__PURE__ */ e.createElement("svg", { className: o.svg, xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
          "circle",
          {
            ...p,
            r: `${l / 3.25}rem`,
            className: o.outline
          }
        ), s && /* @__PURE__ */ e.createElement(
          "circle",
          {
            ...p,
            r: `${l / 6.25}rem`,
            className: o.fill
          }
        ))
      ),
      a && /* @__PURE__ */ e.createElement(
        N,
        {
          tagName: "label",
          id: R(`${n}-${r}`),
          responsive: !0,
          className: o.label
        },
        a
      )
    );
  }
);
y.displayName = "Radio";
const P = ({
  id: r,
  children: n,
  error: a,
  label: s,
  ariaLabelledBy: d
}) => {
  const c = e.Children.toArray(n), i = a ? `${r}-error-message` : void 0, m = "radiogroup-label", _ = `${r}-radiogroup-name`;
  return /* @__PURE__ */ e.createElement("div", null, s && /* @__PURE__ */ e.createElement(u.Body, { tagName: "label", id: m, responsive: !0 }, s), /* @__PURE__ */ e.createElement(
    "div",
    {
      id: r,
      role: "radiogroup",
      className: o.radioGroup,
      "aria-invalid": !!a,
      "aria-labelledby": d ?? m,
      "aria-describedby": i
    },
    c.map(
      (t) => e.isValidElement(t) ? /* @__PURE__ */ e.createElement(
        y,
        {
          ...t.props,
          name: t.props.name || _,
          key: t.props.value,
          error: !!a
        }
      ) : null
    )
  ), i && a && /* @__PURE__ */ e.createElement(w, { id: i }, a));
};
export {
  y as R,
  P as a
};
